// Shared API types between server and client.
//
// These types are DERIVED from the TypeBox schemas in ./schemas.ts (the single
// source of truth that Fastify validates against). This file re-exports them so
// existing import sites keep working, and — crucially — uses `export type` so the
// client bundle never pulls the TypeBox runtime in through this module.

export type {
  SendVerificationRequest,
  SendVerificationResponse,
  SendVerificationErrorResponse,
  CheckVerificationRequest,
  CheckVerificationResponse,
  CheckVerificationErrorResponse,
  LoginPasswordRequest,
  LoginPasswordResponse,
  LoginPasswordErrorResponse,
  LoginPasswordApiResponse,
  SetPasswordRequest,
  SetPasswordResponse,
  SetPasswordErrorResponse,
  SetPasswordApiResponse,
  UpdateNameRequest,
  UpdateNameResponse,
  UpdateNameErrorResponse,
  UpdateNameApiResponse,
  AvailableSlotsQuery,
  AvailableSlot,
  AvailableSlotsResponse,
  AvailableSlotsErrorResponse,
  BookingDensityRequest,
  BookingDensityResponse,
  BookCustomRangeRequest,
  BookSlotRequest,
  BookSlotResponse,
  BookSlotErrorResponse,
  SendVerificationApiResponse,
  CheckVerificationApiResponse,
  AvailableSlotsApiResponse,
  BookSlotApiResponse,
} from './schemas';

// Type guards for response checking
export function isSuccessResponse<T extends { success: boolean }, E extends { error: string }>(
  response: T | E
): response is T {
  return 'success' in response && response.success === true;
}

export function isErrorResponse<T extends { success: boolean }, E extends { error: string }>(
  response: T | E
): response is E {
  return 'error' in response;
}
